import { Percent } from "@silo/types";
import { DebtCurrentState, DebtNewState } from "./types";
import { CurrentApr } from "./current-apr";
import { getDebtCurrentMetrics, getDebtNewMetrics } from "./utils";
import { ProjectedApr } from "./projected-apr";
import { AprState } from "../apr-state";
import { useShowUtilization } from "../hooks";
import { Utilization } from "../utilization";

export interface DebtAprSimulatorProps {
  currentState: DebtCurrentState;
  newState: DebtNewState | null;
  uopt: Percent;
  ucrit: Percent;
  nativeRewardsSymbol: string;
}

export function DebtAprSimulator({
  currentState,
  newState,
  uopt,
  ucrit,
  nativeRewardsSymbol,
}: DebtAprSimulatorProps): JSX.Element {
  const currentMetrics = getDebtCurrentMetrics({
    currentState,
    nativeRewardsSymbol,
    uopt,
    ucrit,
  });

  const newMetrics = getDebtNewMetrics({
    newState,
    nativeRewardsSymbol,
    uopt,
    ucrit,
  });

  const { aprState, utilizationState } = newMetrics ?? currentMetrics;

  const showUtilization = useShowUtilization();

  return (
    <>
      <CurrentApr currentMetrics={currentMetrics} />

      <ProjectedApr currentMetrics={currentMetrics} newMetrics={newMetrics} />

      <AprState aprState={aprState} utilizationState={utilizationState} />

      {showUtilization && (
        <Utilization currentMetrics={currentMetrics} newMetrics={newMetrics} />
      )}
    </>
  );
}
